import { EditorView, keymap } from "@codemirror/view";
import { EditorState } from "@codemirror/state";
import { indentUnit } from "@codemirror/language";
import { indentWithTab } from "@codemirror/commands";
import { oneDark } from "@codemirror/theme-one-dark";
import { basicSetup } from "codemirror";
import { getLanguageExtension } from "./languages";

const noAutocorrect = EditorView.contentAttributes.of({
  autocorrect: "off",
  autocapitalize: "off",
  spellcheck: "false",
});

export function mountEditor(
  parent: HTMLElement,
  path: string,
  value: string,
  onChange: (value: string) => void
): EditorView {
  const state = EditorState.create({
    doc: value,
    extensions: [
      basicSetup,
      oneDark,
      ...getLanguageExtension(path),
      EditorView.lineWrapping,
      indentUnit.of("  "),
      keymap.of([indentWithTab]),
      noAutocorrect,
      EditorView.updateListener.of((update) => {
        if (update.docChanged) {
          onChange(update.state.doc.toString());
        }
      }),
    ],
  });

  return new EditorView({ state, parent });
}
